import styled from 'styled-components'
import Table from '@/components/Table'
import Collapse from '@kunukn/react-collapse'
import TableHeader from '../../Table/components/TableHeader'
import TableCell from '../../Table/components/TableCell'

const StyledTable = styled(Table)`
  ${({ theme }) => `
    margin-top: 1rem;

    .table-head-cell,
    .table-cell {
      text-align: center;
    }

    .table-cell {
      justify-content: center;
    }

    ${theme.mediaQueries.phoneDS} {
      text-align: right;

      .table-row {
        margin: 0;

        .table-row-inner {
          justify-content: flex-start;
        }

        .table-collapse-inner {
          padding: 0;

          .table-row {
            border: none;
            box-shadow: none;
          }

          .table-cell {
            width: 50%;
          }
        }
      }

    }
  `}
`

const TableHeaderDesktop = styled(TableHeader)`
  position: sticky;
  top: 7rem;
  padding: 0.5rem 0;
  z-index: 1;
  background: ${({theme}) => theme.colors.white};
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${({ theme }) => theme.mediaQueries.tabletDS} {
    padding-left: 1rem;
    padding-top: 1rem;
    top: 15rem;
  }
`
const TableHeaderDesktopTooltips = styled(TableHeader)`
  position: sticky;
  top: 11rem;
  padding: 0.5rem 0;
  z-index: 1;
  padding-bottom: 1rem;
  background: ${({theme}) => theme.colors.white};
  display: flex;
  flex-direction: row;
  border-bottom: 1px ${({ theme }) => theme.colors.buttonSolidTertiaryHover} solid;


  ${({ theme }) => theme.mediaQueries.tabletDS} {
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    top: 19rem;
  }
`

const TableHeaderCellDesktop = styled(TableCell)`
    ${({ theme }) => theme.mediaQueries.tabletDS} {
      text-align: left;
      font-size: 0.85rem;
    }
`

const TodayPriceWrap = styled.div`
  ${({ theme }) => `
    line-height: 1;

    &.red {
      .percentage, p { color: ${({ theme }) => theme.colors.pricingRed};}
      .percentage { background-color: ${({ theme }) => theme.colors.pricingRedBackground};}
    }

    &.amber {
      .percentage, p { color: ${({ theme }) => theme.colors.pricingAmber};}
      .percentage { background-color: ${({ theme }) => theme.colors.pricingAmberBackground};}
    }

    &.green {
      .percentage, p { color: ${({ theme }) => theme.colors.pricingGreen};}
      .percentage { background-color: ${({ theme }) => theme.colors.pricingGreenBackground};}
    }

    .percentage, p { 
      font-weight: 600; 
    }

    .percentage {
      padding: .2rem .8rem;
      margin-right: 1rem;
      border-radius: .2rem;
    }

    p { 
      display: inline-block; 
    }

    ${theme.mediaQueries.phoneDS} {
      display: flex;
      flex-wrap: wrap;
      padding-right: 1.2rem;

      .percentage { 
        margin-right: .5rem;
        margin-bottom: .5rem;
      }
    }
  `}
`

const Season = styled.p`
  padding: .5rem;
  border-radius: 2px;
  display: inline-block;
  width: 100%;
  height: 100%;
  word-break: break-word;

  &.winter { background-color: ${({ theme }) => theme.colors.pricingWinter}; }
  &.off-peak-january-february { background-color: ${({ theme }) => theme.colors.pricingOffPeakJanuaryFebruary}; }
  &.february-ht { background-color: ${({ theme }) => theme.colors.pricingFebruaryHt}; }
  &.off-peak-november-december { background-color: ${({ theme }) => theme.colors.pricingOffPeakNovemberDecember}; }
  &.xmas-and-nye { background-color: ${({ theme }) => theme.colors.pricingXmasAndNye}; }
  &.low { background-color: ${({ theme }) => theme.colors.pricingLow}; }
  &.autumn { background-color: ${({ theme }) => theme.colors.pricingAutumn}; }
  &.october-ht { background-color: ${({ theme }) => theme.colors.pricingOctoberHt}; }
  &.off-peak-october { background-color: ${({ theme }) => theme.colors.pricingOffPeakOctober}; }
  &.off-peak-september { background-color: ${({ theme }) => theme.colors.pricingOffPeakSeptember}; }
  &.spring { background-color: ${({ theme }) => theme.colors.pricingSpring}; }
  &.easter { background-color: ${({ theme }) => theme.colors.pricingEaster}; }
  &.post-easter { background-color: ${({ theme }) => theme.colors.pricingPostEaster}; }
  &.whitsun { background-color: ${({ theme }) => theme.colors.pricingWhitsun}; }
  &.off-peak-spring { background-color: ${({ theme }) => theme.colors.pricingOffPeakSpring}; }
  &.off-peak-may { background-color: ${({ theme }) => theme.colors.pricingOffPeakMay}; }
  &.mayday { background-color: ${({ theme }) => theme.colors.pricingMayday}; }
  &.summer { background-color: ${({ theme }) => theme.colors.pricingSummer}; }
  &.summer-peak { background-color: ${({ theme }) => theme.colors.pricingSummerPeak}; }
  &.off-peak-may-june-july { background-color: ${({ theme }) => theme.colors.pricingOffPeakMayJuneJuly}; }
  &.peak { background-color: ${({ theme }) => theme.colors.pricingPeak}; }

  ${({ theme }) => theme.mediaQueries.phoneDS} {
    text-align: center;
    padding: .5rem !important;
  }
`

const TickIcon = styled.span`
  width: 20px;
  height: 20px;
  position: relative;
  border-radius: 50%;
  margin-left: 0.5rem;
  display: inline-block;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  vertical-align: text-bottom;

  &::before, &::after {
    height: 1px;
    content: " ";
    position: absolute;
    background-color: ${({ theme }) => theme.colors.primary};
  }

  &::before {
    width: 5px;
    left: 3px;
    top: 10px;
    transform: rotate(45deg);
  }

  &::after {
    width: 10px;
    left: 6px;
    top: 9px;
    transform: rotate(-45deg);
  }
`

const MobileItem = styled.div`
  overflow: hidden;
  margin-top: 1rem;
  border-radius: .2rem;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 5px 0px ${({ theme }) => theme.colors.pricingBoxShadow};
`

const MobileItemContent = styled.div`
  ${({ isActive }) => `
    margin: 1rem;
    display: flex;
    position: relative;
    align-items: center;

    & > * {
      flex: 1;
    }

    .mobile-item-date, 
    .mobile-item-income, 
    ${TodayPriceWrap} {
      opacity: 1;
      transition: 0.2s all ease;
    }

    ${isActive ? `
      .mobile-item-income, ${TodayPriceWrap} {
        opacity: 0;
      }

      .mobile-item-date {
        font-size: 1rem;
        font-weight: bold;
      }
    ` : ''}

    
  `}
`

const MobileItemCollapse = styled(Collapse)`
  transition: height 280ms cubic-bezier(0.4, 0, 0.2, 1);
`

const MobileItemCollapseRow = styled.div`
  display: flex;
  margin: 1rem;
  align-items: center;

  span { flex: 2; }
  div, p { flex: 1; }

`

const Chevron = styled.span`
  ${({ isActive, theme }) => `
      right: 0;
      width: 10px;
      height: 10px;
      display: block;
      cursor: pointer;
      position: absolute;

      &::before {
          top: 0;
          right: 0;
          bottom: 0;
          content: "";
          width: 10px;
          margin: auto;
          height: 10px;
          display: block;
          position: absolute;
          transition: 0.2s transform ease;
          border-bottom: 2px solid ${theme.colors.blackTwo};
          border-right: 2px solid ${theme.colors.blackTwo};
          transform: ${isActive ? 'rotate(-135deg)' : 'rotate(45deg)'}; 
      } 
  `}
`

export { StyledTable, TodayPriceWrap, Season, TickIcon, MobileItem, MobileItemContent, MobileItemCollapse, MobileItemCollapseRow, Chevron, TableHeaderDesktop, TableHeaderDesktopTooltips, TableHeaderCellDesktop }
